var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-prev"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M16.1795 3.26848C15.789 2.87796 15.1559 2.87795 14.7653 3.26848L8.12087 9.91294C6.94961 11.0842 6.94925 12.9831 8.12005 14.1548L14.6904 20.7302C15.0809 21.1207 15.7141 21.1207 16.1046 20.7302C16.4951 20.3396 16.4951 19.7065 16.1046 19.3159L9.53255 12.7439C9.14203 12.3534 9.14203 11.7202 9.53255 11.3297L16.1795 4.68269C16.5701 4.29217 16.5701 3.659 16.1795 3.26848Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow-prev.72e27824bd3f36383d1be510ccfebcf7.svg";
export { ForwardRef as ReactComponent };